import { DXF_COLOR_HEX } from '@dxfom/color/hex'
import { parseDxfFileArrayBuffer } from '@dxfom/dxf'
import { createSvgContents } from '@dxfom/svg'

export const dxfToSvg = (arrayBuffer: ArrayBuffer) => {
  const dxf = parseDxfFileArrayBuffer(arrayBuffer)
  const [svgContents, viewBox] = createSvgContents(dxf, {
    resolveColorIndex: colorIndex => (colorIndex === 7 ? 'black' : DXF_COLOR_HEX[colorIndex]),
  })
  const margin = 8
  const x = viewBox.x - margin
  const y = viewBox.y - margin
  const w = viewBox.w + margin + margin
  const h = viewBox.h + margin + margin
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${x} ${y} ${w} ${h}" width="${w * 2}" height="${h * 2}">${svgContents}</svg>`
}
